import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

/**
 * Standard close button used across the app to keep icon, size, and labeling consistent.
 */
const CloseButton = ({
  onClick,
  ariaLabel = 'close',
  tooltip,
  size = 'small',
  color = 'inherit',
  edge,
  sx,
  ...iconButtonProps
}) => {
  const button = (
    <IconButton
      aria-label={ariaLabel}
      onClick={onClick}
      size={size}
      edge={edge}
      color={color}
      sx={{
        color: color === 'inherit' ? 'currentColor' : undefined,
        '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.05)' },
        ...sx
      }}
      {...iconButtonProps}
    >
      <CloseIcon fontSize={size === 'small' ? 'small' : 'medium'} />
    </IconButton>
  );

  if (tooltip) {
    return (
      <Tooltip title={tooltip} arrow>
        {button}
      </Tooltip>
    );
  }

  return button;
};

export default CloseButton;
